import React from "react";
import {
  Checkbox,
  Stack,
  Link,
  ListItem,
  ListItemText,
  Paper,
} from "@mui/material";
import { ResponseRecommendation } from "@lib/ShiOneClient";

interface PrioritiesTableEntryProps {
  res: ResponseRecommendation;
  isPrint: boolean;
  selectedSourceIds: Set<string>;
  handleCheckRecommendation: (
    event: React.ChangeEvent<HTMLInputElement>,
    res: ResponseRecommendation,
  ) => void;
  handleRecsDialogOpenState: (
    recsValue: ResponseRecommendation | undefined,
    open: boolean,
  ) => void;
}

const PrioritiesRecsTableEntry: React.FC<PrioritiesTableEntryProps> = ({
  res,
  isPrint,
  selectedSourceIds,
  handleCheckRecommendation,
  handleRecsDialogOpenState,
}) => (
  <ListItem key={res.capabilityId} disablePadding>
    <Paper sx={{ mb: 1, mr: 1, p: 1, width: "100%" }} >
      <Stack direction="row" alignItems="flex-start" width="100%">
        <Checkbox
          color="secondary"
          sx={{ mt: -0.5, ml: -0.5 }}
          checked={selectedSourceIds.has(
            `${res?.assessmentId}:${res?.recommendationId}`,
          )}
          disabled={res?.isLinkedToRoadmap}
          onChange={(event) => handleCheckRecommendation(event, res)}
        />
        <ListItemText
          primary={
            <Link
              component="button"
              sx={{ textAlign: "left" }}
              onClick={() =>
                isPrint ? undefined : handleRecsDialogOpenState(res, true)
              }
            >
              {res.capability}
            </Link>
          }
          // v1 uses recommendationsSummary, v2 recommendations
          secondary={res.recommendations || res.recommendationsSummary}
          slotProps={{
            primary: { variant: "subtitle1" }
          }}
        />
      </Stack>
    </Paper>
  </ListItem>
);

export default PrioritiesRecsTableEntry;
